<template>
    <thead>
        <th v-show="h.show == undefined || h.show" v-for="h in headers" @click="orderBy(h)" class="side-by-side" :class="{ 'dw-th': (h.sort == undefined || h.sort) }">
            {{ h.name }}
            <i class="fa fa-sort-up icon-abs" aria-hidden="true" v-if="oBKey == h.key && oBDirection == 'asc'"></i>
            <i class="fa fa-sort-down icon-abs" aria-hidden="true" v-if="oBKey == h.key && oBDirection == 'desc'"></i>
        </th>
        <th v-if="editable">Ações</th>
    </thead>
</template>

<script>
    export default {
        props: {
            headers: {
                type: [Array],
                required: true
            },
            editable: {
                type: Boolean,
                required: true,
                default: true
            }
        },
        data() {
            return {
                oBKey: '',
                oBDirection: 'asc',
            }
        },
        methods: {
            orderBy(field) {
                if (field.sort == undefined || field.sort) {
                    this.oBKey = field.key

                    if (this.oBDirection == 'asc') {
                        this.oBDirection = 'desc'
                    } else if (this.oBDirection == 'desc') {
                        this.oBDirection = 'asc'
                    }

                    this.$emit('update', { key: this.oBKey, direction: this.oBDirection });
                }
            }
        }
    }
</script>

<style lang="scss">
    .dw-th{
        cursor: pointer;
    }
    .side-by-side{
        position: relative;
        padding-right: 17px !important;
        .icon-abs {
            position: absolute;
            top: 15px;
            right: 5px;
        }
    }
    .th-no-valign{
        vertical-align: top !important;
    }

</style>



// WEBPACK FOOTER //
// DWTableHead.vue?02901402